/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpAdminStatsResponseTopPlayersInner
 */
export interface FuelUpAdminStatsResponseTopPlayersInner {
    /**
     * 
     * @type {string}
     * @memberof FuelUpAdminStatsResponseTopPlayersInner
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelUpAdminStatsResponseTopPlayersInner
     */
    username?: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpAdminStatsResponseTopPlayersInner
     */
    totalFuelEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpAdminStatsResponseTopPlayersInner
     */
    prestigeLevel?: number;
}

/**
 * Check if a given object implements the FuelUpAdminStatsResponseTopPlayersInner interface.
 */
export function instanceOfFuelUpAdminStatsResponseTopPlayersInner(value: object): value is FuelUpAdminStatsResponseTopPlayersInner {
    return true;
}

export function FuelUpAdminStatsResponseTopPlayersInnerFromJSON(json: any): FuelUpAdminStatsResponseTopPlayersInner {
    return FuelUpAdminStatsResponseTopPlayersInnerFromJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseTopPlayersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpAdminStatsResponseTopPlayersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'username': json['username'] == null ? undefined : json['username'],
        'totalFuelEarned': json['totalFuelEarned'] == null ? undefined : json['totalFuelEarned'],
        'prestigeLevel': json['prestigeLevel'] == null ? undefined : json['prestigeLevel'],
    };
}

export function FuelUpAdminStatsResponseTopPlayersInnerToJSON(json: any): FuelUpAdminStatsResponseTopPlayersInner {
    return FuelUpAdminStatsResponseTopPlayersInnerToJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseTopPlayersInnerToJSONTyped(value?: FuelUpAdminStatsResponseTopPlayersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'username': value['username'],
        'totalFuelEarned': value['totalFuelEarned'],
        'prestigeLevel': value['prestigeLevel'],
    };
}

